<template>
  <Page>
    <div class="page page--home">
      <LazySkipLinks
        :items="[
          {
            id: 'footer',
            title: 'Go to footer'
          }
        ]" />
      <LazyHomeStoryblok />
      <LazyHomeSubscribeForm />

      <ClientOnly>
        <IntersectionObserver>
          <ProductRecent
            :in-container="true"
            class="h-margin-top-l h-margin-bottom-l" />
        </IntersectionObserver>
      </ClientOnly>
    </div>
  </Page>
</template>

<script setup>
import { formatHomeSchemaOrg } from '~/helpers/metadata'
const { $lang } = useNuxtApp()

useHead({
  title: $t('general/site-title'),
  script: [
    {
      type: 'application/ld+json',
      innerHTML: formatHomeSchemaOrg($lang)
    }
  ]
})
</script>
